import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Index from "@/pages/Index";
import heroPoster from "@/assets/hero-poster.jpg";

export const Route = createFileRoute("/zh-cn/")({
  head: () => ({
    ...buildRouteHead("/zh-cn"),
    // LCP candidate: the hero poster paints before the (deferred) background video.
    links: [{ rel: "preload", as: "image", href: heroPoster, fetchPriority: "high" }],
  }),
  component: Index,
});

